function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import AccountActions from './AccountActions';
import { AbstractTransport } from '@central-products/abstract-transport-bus';
var feature = {
  // tslint:disable-next-line no-any
  init: function init(config) {
    var accountActions = new AccountActions(_objectSpread({
      transport: config.transport || AbstractTransport.getInstance()
    }, config));
    return accountActions.init();
  },
  type: 'account-actions',
  dependsOn: []
};
export default feature;
//# sourceMappingURL=feature.js.map